const actionsRedirect = {
	DEFAULT: ({ token }) => "/carregando-portal/" + token,
	EXCLUSIVE_LEAGUE: ({ token, id_league, cod_campaign }) =>
		`/carregando-portal/${token}/campanha/${cod_campaign}/liga/${id_league}`,
	UPGRATE_PLAN_FROM_EXPLORE: () => `/onboarding/carrinho/plano`,
	TOUR_LEAGUE: ({ token, id_league }) => `/carregando-portal/${token}/tour-liga/${id_league}`,
	FIDELIDADE_PONTOS: ({ token }) => `/carregando-portal/${token}/pontos`,
	JOIN_LEAGUE: ({ token, id_league }) => `/carregando-portal/${token}/league/my-league/${id_league}`,
	REDIRECT_PATH: ({ token, redirect_path }) => `/redirect/${token}/?redirect_path=${redirect_path}`,
};

export const generatePathToLogin = (token) => {
	const id_league = localStorage.getItem("IDLEAGUE") || false;
	const cod_campaign = localStorage.getItem("CODCAMPAIGN") || false;
	const cd_plan = localStorage.getItem("CDPLAN") || false;
	const id_research = localStorage.getItem("IDRESEARCH") || false;
	const redirect_path = localStorage.getItem("REDIRECTPATH") || false;

	const params = {
		id_league,
		cod_campaign,
		cd_plan,
		id_research,
		token,
		redirect_path,
	};

	const inFidelidade = window.location.href.includes("pontos");

	if (redirect_path) return actionsRedirect.REDIRECT_PATH(params);
	if (inFidelidade) return actionsRedirect.FIDELIDADE_PONTOS(params);
	if (!!id_league && !!cod_campaign) return actionsRedirect.EXCLUSIVE_LEAGUE(params);
	if (!!cd_plan && !!id_research) return actionsRedirect.UPGRATE_PLAN_FROM_EXPLORE();
	if (!!id_league && !isNaN(id_league)) return actionsRedirect.TOUR_LEAGUE(params);
	if (!!id_league && isNaN(id_league)) return actionsRedirect.JOIN_LEAGUE(params);
	return actionsRedirect.DEFAULT(params);
};
